import type { BulletinBoard } from '@autopass-web/types';

export const parseApsStyles = (apsPartnerTemplate: BulletinBoard) => {
  const entryImage = apsPartnerTemplate?.attributes?.entry_image;
  const appBackgroundColor =
    apsPartnerTemplate?.attributes?.app_background_color;
  const appTextColor = apsPartnerTemplate?.attributes?.app_text_color;

  const appBackgroundStyleObj = appBackgroundColor
    ? { background: appBackgroundColor }
    : {};
  const appTextStyleObj = appTextColor ? { color: appTextColor } : {};

  return {
    entryImage,
    appBackgroundColor,
    appTextColor,
    appBackgroundStyleObj,
    appTextStyleObj,
  };
};
